import React, { Component } from "react";

// Import authService
import { Link, Redirect } from "react-router-dom";
import { DataToken } from "../../../function/Format";
// import { JENIS_DESA } from "../../../function/Koneksi";
import MenuAdmin from "./menu.admin";
import MenuSuper from "./menu.superadmin";
import MenuWisata from "./menu.admin-wisata";
import MenuOperator from "./menu.superoperator";
import MenuAdminWeb from "./menu.admin-website";
import MenuEnumerator from "./menu.enumerator";
import Notificationbaru from "./notification.baru";
import UserMenu from "./user-menu.component";
import { ID_DESA, GetWisata, GetMain } from "../../../function/Koneksi";
// import { borderRadius } from "react-select/src/theme";

class HeaderBaru extends Component {
  constructor(props) {
    super(props);
    this.state = {
      alert: null,
      show: false,
      basicTitle: "",
      basicType: "default",
      pesanAlert: "",
      layanan: [],
      perizinan: [],
      navMenus: false,
      sidebar: false,
      navigate: false,
      countHari: '',
      akun: DataToken(sessionStorage.getItem("access_token"))
    };
  }
  logOut(e) {
    e.preventDefault();
    if(this.state.akun.sub.data_role === undefined){
      GetWisata("auth/logout/"+this.state.akun.sub.uuid, null, data => {
        // console.log('data logout bouss');
        // console.log(data);
      })
    }

    sessionStorage.removeItem("access_token");
    // localStorage.clear();
    this.setState({ navigate: true });
  }

  openCloseSidebar = () => {
    if (this.state.sidebar) {
      this.setState({ sidebar: false });
      document
        .querySelector(".page-body-wrapper")
        .classList.add("sidebar-close");
    } else {
      this.setState({ sidebar: true });
      document
        .querySelector(".page-body-wrapper")
        .classList.remove("sidebar-close");
    }
  };
  componentDidMount() {
    var contentwidth = window.innerWidth;
    if (contentwidth > 1) {
      document
        .querySelector(".page-body-wrapper")
        .classList.add("sidebar-close");
    }

    GetMain("main/web/list-layanan-desa", ID_DESA, data => {
      if (data.result) {
      
        if(data.result.data_api.data_invoice!==null){
          let tgl = Date.now();
          let set_tgl = new Intl.DateTimeFormat('en-US', {year: 'numeric', month: '2-digit',day: '2-digit'}).format(tgl);
          let ex_tgl = set_tgl.split("/");
          let hari_ini = ex_tgl[2] + "-" + ex_tgl[0] + "-" + ex_tgl[1];
          
          let expired = data.result.data_api.data_invoice.tgl_expired;
          let ex_tgl_expired = expired.split(' ');
          let tgl_expired = ex_tgl_expired[0];
          
          let set_hari_ini = new Date(hari_ini)
          let set_expired = new Date(tgl_expired)

          // Calculating the time difference of two dates
          let Difference_In_Time = set_expired.getTime() - set_hari_ini.getTime();

          // Calculating the no. of days between two dates
          let Difference_In_Days = Math.round(Difference_In_Time / (1000 * 3600 * 24));

          // Kondisi expired
          this.setState({ 
            countHari: Difference_In_Days === 0 ? 'nol' : Difference_In_Days, 
          })
        }
      }
    })
  }

  render() {
    const { navigate} = this.state;
    if (navigate) {
      return <Redirect to="/" push={true} />;
    }

    let logoAplikasi = (
      <img
        className="align-self-center"
        src={ require("../../../assets/images/logo-ld.webp").default}
        alt="logo-aplikasi"
        style={{ height: '43px' }}
      />
    )

    switch (localStorage.getItem('JENIS_APLIKASI').toLowerCase()) {
      case 'halaman kampung':
        logoAplikasi = (
          <img
            className="align-self-center"
            src={ require("../../../assets/images/hk_icon.png")}
            alt="logo-aplikasi"
            style={{ height: '43px' }}
          />
        )
        break;
      case 'amanat nagari':
        logoAplikasi = (
          <img
            className="align-self-center"
            src={ require("../../../assets/images/amanat_nagari_logo.png")}
            alt="logo-aplikasi"
            style={{ height: '43px' }}
          />
        )
        break;
      default:
        logoAplikasi = (
          <img
            className="align-self-center"
            src={ require("../../../assets/images/logo-ld.webp").default}
            alt="logo-aplikasi"
            style={{ height: '43px' }}
          />
        )
        break; 
    }

    return (
      <div className="bayu-main-header">
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <div className="bayu-header-right" style={{ width: "fit-content" }}>
            {
              this.state.countHari
              ?
                <div className="notif-expired" style={{textAlign: 'left', color: this.state.countHari && this.state.countHari > 30?'green':this.state.countHari && this.state.countHari >= 7?'orange':'red'}}>
                  {
                    this.state.countHari>0
                    ?
                      <b><i className="icofont icofont-clock-time"></i> Masa Aktif Layanan: {this.state.countHari} Hari</b>
                    :
                    this.state.countHari === 'nol'
                    ?
                      <b><i className="icofont icofont-clock-time"></i> Layanan Expired Sejak: Hari Ini</b>
                    :
                      <b><i className="icofont icofont-clock-time"></i> Layanan Expired Sejak: {Math.abs(this.state.countHari)} Hari Lalu</b>
                  }
                </div>
              :''
            }
            <div className="mobile-sidebar">
              <div className="media-body text-right switch-sm">
                <i onClick={this.openCloseSidebar} className="fa fa-bars" />
              </div>
            </div>
          </div>

          <div className="bayu-header-left">
            <div className="logo-wrapper" style={{ display: 'flex', alignItems: 'center' }}>
              {/* <a href="/"> */}
              <Link data-testid="btnLogoAplikasi" to={process.env.PUBLIC_URL}>
                {logoAplikasi}
              </Link>
            </div>
          </div>
          <div className="bayu-header-right" style={{ width: "fit-content" }}>
            <div className="nav-right">
              <ul>
                <li>
                  <Link to={process.env.PUBLIC_URL + '/admin/request-surat'}>
                    <i className="icofont icofont-unique-idea"></i>
                    <i className="icofont icofont-attachment"></i>
                    {/* <i className="icofont icofont-archive pow"></i> */}
                  </Link>
                </li>
                <UserMenu />
                {
                  this.state.akun.sub.data_role !== undefined
                  ?
                    this.state.akun.sub.data_role.nama_role === "Admin" ? 
                    (
                    <Notificationbaru 
                      dataNotif={this.props.dataNotif}
                      totalNotif={this.props.totalNotif}
                      paginationNotif={this.props.paginationNotif}
                      pesanNotif={this.props.pesanNotif}
                      moreNotif={this.props.moreNotif}
                      refreshNotif={this.props.refreshNotif}
                    />
                    ) : ''
                    :
                    <></>
                  }

                <li>
                  <a href="/" onClick={this.logOut.bind(this)}>
                    <i className="icofont icofont-logout pow"></i>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        {
          this.state.akun.sub.data_role !== undefined ?
            this.state.akun.sub.data_role.nama_role === "Admin" ? (
                <MenuAdmin paid={this.props.paid} lisensi={this.props.lisensi} />
              ) : this.state.akun.sub.data_role.nama_role === "Super Operator" ?
              (
                <MenuOperator />
              ) : this.state.akun.sub.data_role.nama_role === "Admin Website" ?
              (
                <MenuAdminWeb />
              )  : this.state.akun.sub.data_role.nama_role === "Enumerator" ?
              (
                <MenuEnumerator />
              )
                :
              (
                <MenuSuper />
              )
            :
            <MenuWisata />

        }
      </div>
    );
  }
}

export default HeaderBaru;
